import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Calendar } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { hasPremiumAccess } from "@/lib/access";

export default function News() {
  const [articles, setArticles] = useState([]);
  const [weekly, setWeekly] = useState([]);
  const { user } = useAuth();
  const premium = hasPremiumAccess(user);

  useEffect(() => {
    api.get("/articles").then(({ data }) => setArticles(data)).catch(() => {});
    api.get("/weekly").then(({ data }) => setWeekly(data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <div className="max-w-2xl">
        <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37] mb-3">Content & Growth</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold">Industry news & drops.</h1>
        <p className="mt-4 text-neutral-400">Fresh every week. Some breakdowns are reserved for members.</p>
      </div>

      {/* weekly engine */}
      <div className="mt-12">
        <div className="flex items-center gap-2 text-[#D4AF37] mb-4"><Calendar size={16} /><span className="font-mono text-xs uppercase tracking-wider">Weekly Content Engine</span></div>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {weekly.map((w) => (
            <div key={w.id} className={`border p-4 ${w.locked ? "bg-[#0a0a0a] border-[#D4AF37]/20" : "bg-[#0a0a0a] border-white/10"}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-[#D4AF37]">{w.day}</span>
                {w.locked && <Lock size={12} className="text-[#D4AF37]" />}
              </div>
              <h4 className="mt-2 font-display font-semibold">{w.title}</h4>
              <p className="mt-1 text-xs text-neutral-500">{w.description}</p>
              {w.locked && <Link to="/pricing" className="mt-2 inline-block text-xs text-[#D4AF37]">Unlock →</Link>}
            </div>
          ))}
        </div>
      </div>

      {/* articles */}
      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {articles.map((a) => {
          const locked = a.premium && !premium;
          return (
            <Link key={a.id} to={locked ? "/pricing" : `/article/${a.slug}`} data-testid={`article-${a.slug}`}
              className="group block bg-[#111] border border-white/10 overflow-hidden hover:-translate-y-1 hover:border-[#D4AF37]/40 transition-transform duration-300">
              <div className="relative h-48 overflow-hidden">
                <img src={a.cover} alt={a.title} className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${locked ? "grayscale" : ""}`} />
                <span className="absolute top-3 left-3 text-xs font-mono uppercase bg-black/70 border border-white/10 px-2 py-1 text-neutral-200">{a.category}</span>
                {a.premium && <span className="absolute top-3 right-3 flex items-center gap-1 bg-[#D4AF37] text-black text-xs font-mono px-2 py-1"><Lock size={11} /> Members</span>}
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-semibold leading-snug">{a.title}</h3>
                <p className="mt-2 text-sm text-neutral-400 line-clamp-2">{a.excerpt}</p>
                {locked && <p className="mt-3 text-xs text-[#D4AF37]">Upgrade to read →</p>}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
